import { render, staticRenderFns } from "./whatsapp-order-panel.vue?vue&type=template&id=74096110&scoped=true"
import script from "./whatsapp-order-panel.vue?vue&type=script&lang=js"
export * from "./whatsapp-order-panel.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-order-panel.vue?vue&type=style&index=0&id=74096110&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74096110",
  null
  
)

export default component.exports